<template>
  <div class="container">
    <div class="row">
    <div class="col">
    <header class="game-definition-form-header">
      <h1>Set Roster</h1>
      <p><em>Who's playing {{gameDefinition.name }}?</em></p>
    </header>
    </div>
    </div>
    <div class="row">
    <div class="col">
    <form @submit.prevent="handleSubmit" class="game-definition-form">
      <div class="form-row">
        <label for="tags" title="Please Enter One Player Then hit Enter to Add More players">Players</label>
                <vue-tags-input
            v-model="tag"
            :placeholder='"Type each name and hit enter"'
            :tags="tags"
            @tags-changed="newTags => tags = newTags"
          />
      </div>
      <div class="form-row">
        <button class="btn-primary" :disabled="tags.length == 0">Play!</button>
        <router-link class="btn" to="/new-game">Cancel</router-link>
      </div>
    </form>
    </div>
    </div>
            
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: 'BuildRoster',
    components: {
        VueTagsInput
    },
    props: ["index", "gameDefinition"],
    data() {
        return {
            tags: [],
            tag: ''
        }
    },
    mounted() {
      this.gameDefinition = this.$route.params.gameDefinition
    },
    methods: {
      handleSubmit() {
        const data = {
          gameDefinitionName: this.gameDefinition.name,
          gameDefinitionId: this.gameDefinition.id,
          roster: this.tags.map(tag => tag.text)
        };
        this.$store.dispatch('games/newGame', data).then((response) => {
          this.$router.push({ name: 'game-details', params: { id: response.id }})
        });
      }
    }
  }
</script>

<style scoped='true'>
.container {
  display: flex; /* or inline-flex */
  flex-direction: column;
  align-content: center;
  /* background-color: white; */
}

.row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: space-around;
  align-content: center;
}
.row > * {
  flex: 1 100%;
}

.col {
  padding: 5px;
  display: flex; /* or inline-flex */
  justify-content: space-around;
  
  line-height: 15px;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}


.game-definition-form-header {
  text-align: center;
  background-color: white;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
}

.game-definition-form-header h1 {
  font-size: 30px;
  margin-bottom: 20px;
}

.game-definition-form {
  background-color: white;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  
  width: 80%;
  padding: 50px;
  margin: 0 0 40px 0;
}

.form-row {
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
}

.form-row input[type='text'],
.form-row input[type='number'] {
  background-color: #FFFFFF;
  border: 1px solid #D6D9DC;
  border-radius: 3px;
  width: 100%;
  padding: 7px;
  font-size: 14px;
}

.form-row label {
  margin-bottom: 15px;
}

.form-row input[type='text']:invalid,
.form-row input[type='number']:invalid {
  border: 1px solid #D55C5F;
  color: #D55C5F;
  box-shadow: none; /* Remove default red glow in Firefox */
}

.legacy-form-row {
  border: none;
  margin-bottom: 40px;
}

.legacy-form-row legend {
  margin-bottom: 15px;
}

.legacy-form-row .radio-label {
  display: block;
  font-size: 14px;
  padding: 0 20px 0 10px;
}

.legacy-form-row input[type='radio'] {
  margin-top: 2px;
}
  
.labeled-radio,
.legacy-form-row .radio-label,
.legacy-form-row input[type='radio'] {
  float: left;
}

.form-row select {
  width: 100%;
  padding: 5px;
  font-size: 14px;            /* This won't work in Chrome or Safari */
  -webkit-appearance: none;   /* This will make it work */
}

.form-row textarea {
  font-family: "Helvetica", "Arial", sans-serif;
  font-size: 14px;

  border: 1px solid #D6D9DC;
  border-radius: 3px;

  min-height: 200px;
  margin-bottom: 10px;
  padding: 7px;
  resize: none;
}

.form-row .instructions {
  color: #999999;
  font-size: 14px;
  margin-bottom: 30px;
}

.form-row .checkbox-label {
  margin-bottom: 0;
}

.form-row button {
  font-size: 16px;
  font-weight: bold;

  color: #FFFFFF;
  background-color: #5995DA;

  border: none;
  border-radius: 3px;

  padding: 10px 40px;
  cursor: pointer;
}

.form-row button:hover {
  background-color: #76AEED;
}

.form-row button:active {
  background-color: #407FC7;
}

@media only screen and (min-width: 700px) {
  .game-definition-form-header,
  .game-definition-form {
    width: 600px;
  }
  .labeled-radio {
    flex-direction: column;
    align-items: flex-start; /* To avoid stretching */
    margin-bottom: 20px;
  }
  .form-row {
    flex-direction: row;
    align-items: flex-start; /* To avoid stretching */
    margin-bottom: 20px;
  }
  .form-row input[type='text'],
  .form-row input[type='number'],    /* Add */
  .form-row select,                 /* These */
  .form-row textarea {
    width: 250px;
    height: initial;
  }
  .form-row label {
    text-align: right;
    width: 120px;
    margin-top: 7px;
    padding-right: 20px;
  }

  .legacy-form-row {
    margin-bottom: 10px;
  }
  .legacy-form-row legend {
    width: 120px;
    text-align: right;
    padding-right: 20px;
    font-size: 1rem;
    float: left;
  }

  .form-row .instructions {
    margin-left: 120px;
  }

  .form-row .checkbox-label {
    margin-left: 120px;
    width: auto;
  }
  
  .form-row checkbox {
    padding-left: 120px;
    width: auto;
  }
  
  .form-row button {
    margin-left: 120px;
  }  
}
</style>